// react hooks not required in this wrapper; the desktop hook uses them
import { ConnectionStatus } from '../types';
import { isMobile, isWeb } from '../../environment';
// localComms not used here; desktop hook handles subscription
import { useDesktopDeviceStatus } from './useDesktopDeviceStatus';

// Try to import RN SDK hook directly for mobile platforms
let rnUseLocalDeviceStatus: (() => ConnectionStatus | null | undefined) | null =
  null;
try {
  const rnOrdersSDK = require('@oolio-group/rn-orders-sdk');
  rnUseLocalDeviceStatus = rnOrdersSDK.useLocalDeviceStatus;
} catch {
  // RN SDK not available
}

/**
 * Hook to get local device status from the Orders SDK.
 * Uses RN SDK hook for mobile, local implementation for desktop/web.
 */
export function useLocalDeviceStatus(): ConnectionStatus | null | undefined {
  // Always call hooks at top-level so order doesn't change
  const desktopStatus = useDesktopDeviceStatus();

  // Mobile: prefer RN SDK hook if available
  if (isMobile() && rnUseLocalDeviceStatus) {
    return rnUseLocalDeviceStatus();
  }

  // If running on web (no local comms), warn and return null
  if (isWeb()) {
    console.warn('[useLocalDeviceStatus] No SDK instance available');
    return null;
  }

  // Desktop: return desktop hook status
  return desktopStatus;
}

/**
 * Legacy hook for compatibility - use useLocalDeviceStatus instead
 * @deprecated Use useLocalDeviceStatus directly
 */
export const useLocalDevices = () => {
  useLocalDeviceStatus();
  // This hook is just for side effects like the mobile version
};
